// extracted by mini-css-extract-plugin
export default {"monthSelector":"sale_list_monthSelector__lJmmn","arrowBtn":"sale_list_arrowBtn__x4Dsw","monthText":"sale_list_monthText__P8DeQ"};